import type { ServiceResponseDto } from '../types/api/service';
import type { LogSearchRequestDto, LogSearchResponseDto } from '../types/api/logSearch';
import { BaseServiceClient } from './BaseServiceClient';

/**
 * AdminLogService
 *
 * Adapter for the admin_log_search backend operation (sync service).
 */
export class AdminLogService extends BaseServiceClient {
  constructor(apiService: any) {
    super(apiService);
  }

  async searchLogs(request: LogSearchRequestDto): Promise<LogSearchResponseDto> {
    let response: ServiceResponseDto;
    try {
      response = await this.callService('admin_log_search', request);
    } catch (err: any) {
      throw new Error(`admin_log_search failed: ${err?.message ?? 'unknown error'}`);
    }

    if (!response.success) {
      throw new Error(`admin_log_search error: ${response.message || response.errorDescription}`);
    }

    try {
      return JSON.parse(response.payload) as LogSearchResponseDto;
    } catch {
      throw new Error('admin_log_search: failed to parse response payload');
    }
  }
}
